import { Injectable } from '@angular/core';
import EventEmitter from 'events';
import { TEvent } from './types';

@Injectable({
    providedIn: 'root',
})
export class EventService {
    private _emitter = new EventEmitter();

    public constructor() {}

    public on<T>(ev: TEvent, handler: (data?: any) => void) {
        this._emitter.on(ev, handler);
    }

    public emit<T>(ev: TEvent, data?: T | undefined) {
        this._emitter.emit(ev, data);
    }
}
